"use client";

import Image from "next/image";
import React, { useEffect, useState } from "react";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FormHeading,
  OtherFormCategory,
  SuccessMessageType,
} from "@/interface/types";

const images = [
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/dubai_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/newyork_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/bangalore_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/chennai_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/mumbai_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/delhi_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/ahmedabad_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/kochi_desktop_updated._bannerwebp.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/hyderabad_desktop_updated_bannerwebp.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/kolkata_desktop_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/pune_desktop_updated_banner.webp",
];

const mob_images = [
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/dubai_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/newyork_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/bangalore_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/chennai_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/mumbai_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/delhi_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/ahmedabad_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/kochi_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/hyderabad_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/kolkata_mobile_updated_banner.webp",
  "https://ik.imagekit.io/mileseducation/miles_website/contact-us/pune_mobile_updated_banner.webp",
];

const locationData = [
  {
    city: "Dubai",
    address:
      "Miles CareerGraph DMCC, Jumeirah Bay Tower X2, 3rd Floor, Jumeirah Lakes Towers PO BOX 126845, Nearest Metro SHOBHA REALTY",
    statePin: "Dubai, UAE",
    phone: "+971-506087199",
    phone_no: "971-506087199",
    email: "yavanika.meru@mileseducation.com",
    leftMdDesktop: "225px",
    bottomMdDesktop: "178px",
    leftLgDesktop: "262px",
    bottomLgDesktop: "214px",
    leftMobile: "157px",
    bottomMobile: "50px",
  },
  {
    city: "New York",
    address: "Miles Talent Hub, 100 United Nations Plaza, Apt#45C,",
    statePin: "NYC 10017",
    phone: "+1-347-301-9910",
    phone_no: "1-347-301-9910",
    email: "rohini.sripada@mileseducation.com",
    leftMdDesktop: "299px",
    bottomMdDesktop: "223px",
    leftLgDesktop: "299px",
    bottomLgDesktop: "223px",
    leftMobile: "116px",
    bottomMobile: "50px",
  },
  {
    city: "Bangalore",
    address: "2nd Floor, Mantri Avenue, Koramangala 8th Block,",
    statePin: "Bangalore - 560047",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "bangalore@mileseducation.com",
    leftMdDesktop: "377px",
    bottomMdDesktop: "200px",
    leftLgDesktop: "377px",
    bottomLgDesktop: "200px",
    leftMobile: "134px",
    bottomMobile: "50px",
  },
  {
    city: "Chennai",
    address:
      "3rd Floor, 91 Springboard, Etica Malar Aurum, B-12, Guindy Industrial Estate, SIDCO Industrial Estate, Guindy,",
    statePin: "Chennai, Tamil Nadu – 600032",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "chennai@mileseducation.com",
    leftMdDesktop: "377px",
    bottomMdDesktop: "200px",
    leftLgDesktop: "377px",
    bottomLgDesktop: "200px",
    leftMobile: "124px",
    bottomMobile: "50px",
  },
  {
    city: "Mumbai",
    address:
      "1st Floor, AJ House Abengoa, Marol Maroshi Rd, Gamdevi, Marol, Andheri East,",
    statePin: "Mumbai, Maharashtra 400059",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "mumbai@mileseducation.com",
    leftMdDesktop: "337px",
    bottomMdDesktop: "350px",
    leftLgDesktop: "337px",
    bottomLgDesktop: "350px",
    leftMobile: "142px",
    bottomMobile: "50px",
  },
  {
    city: "Delhi",
    address:
      "3rd and 4th Floor, Old Fort Building, Near DLF Mall, Main Road, Saket,",
    statePin: "New Delhi, Delhi 110017",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "delhincr@mileseducation.com",
    leftMdDesktop: "395px",
    bottomMdDesktop: "130px",
    leftLgDesktop: "395px",
    bottomLgDesktop: "130px",
    leftMobile: "143px",
    bottomMobile: "50px",
  },
  {
    city: "Ahmedabad",
    address: "704 Satyaone Complex, Near Helmet Cross Road, Memnagar,",
    statePin: "Ahmedabad - 380052",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "ahmedabad@mileseducation.com",
    leftMdDesktop: "400px",
    bottomMdDesktop: "250px",
    leftLgDesktop: "400px",
    bottomLgDesktop: "250px",
    leftMobile: "126px",
    bottomMobile: "50px",
  },
  {
    city: "Kochi",
    address: "11th Floor, Muthoottu Royal tower, 36, Banerji Road, Kaloor,",
    statePin: "Ernakulam, Kerala 682017",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "kochi@mileseducation.com",
    leftMdDesktop: "387px",
    bottomMdDesktop: "325px",
    leftLgDesktop: "387px",
    bottomLgDesktop: "325px",
    leftMobile: "131px",
    bottomMobile: "50px",
  },
  {
    city: "Hyderabad",
    address:
      "Level - 1, Jayabheri Silicon Towers, Hitech City Road, Kothaguda,",
    statePin: "Hyderabad - 500084",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "hyderabad@mileseducation.com",
    leftMdDesktop: "382px",
    bottomMdDesktop: "269px",
    leftLgDesktop: "382px",
    bottomLgDesktop: "269px",
    leftMobile: "131px",
    bottomMobile: "50px",
  },
  {
    city: "Kolkata",
    address: "Collab Deck, 2/1, Russel St, Kankaria Estates, Park Street area,",
    statePin: "Kolkata, West Bengal 700071",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "kolkata@mileseducation.com",
    leftMdDesktop: "269px",
    bottomMdDesktop: "217px",
    leftLgDesktop: "269px",
    bottomLgDesktop: "217px",
    leftMobile: "131px",
    bottomMobile: "50px",
  },
  {
    city: "Pune",
    address:
      "Sprint Workspace Wakadewadi, Old Mumbai - Pune Hwy, Narveer Tanaji Wadi, Shivajinagar,",
    statePin: "Pune, Maharashtra 411001",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "pune@mileseducation.com",
    leftMdDesktop: "377px",
    bottomMdDesktop: "265px",
    leftLgDesktop: "377px",
    bottomLgDesktop: "265px",
    leftMobile: "131px",
    bottomMobile: "50px",
  },
];

const ContactBanner = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000); // autoplay every 4s
    return () => clearInterval(interval);
  }, []);

  // Generate CSS for each location
  const generateLocationStyles = () => {
    return locationData
      .map(
        (location, index) => `
      .overlay-location-${index} {
        left: 50%;
        transform: translateX(-50%);
        bottom: ${location.bottomMobile};
      }
      @media (min-width: 768px) and (max-width: 1023px) {
        .overlay-location-${index} {
          left: ${location.leftMdDesktop} !important;
          transform: none !important;
          bottom: ${location.bottomMdDesktop} !important;
        }
      }
      @media (min-width: 1024px) {
        .overlay-location-${index} {
          left: ${location.leftLgDesktop} !important;
          transform: none !important;
          bottom: ${location.bottomLgDesktop} !important;
        }
      }
    `,
      )
      .join("\n");
  };

  return (
    <>
      {/* eslint-disable-next-line react/no-danger */}
      <style dangerouslySetInnerHTML={{ __html: generateLocationStyles() }} />
      <div
        className="w-full bg-white relative md:h-[700px] h-[670px] overflow-hidden
        md:bg-[url('https://ik.imagekit.io/mileseducation/miles_website/contact-us/contact_bg_desktop.webp')]
        bg-[url('https://ik.imagekit.io/mileseducation/miles_website/contact-us/contact_bg_mobile.webp')]
        bg-no-repeat bg-top bg-cover"
      >
        {/* Desktop image slider */}
        <div className="md:block hidden">
          <div className="md_desktop absolute bottom-0 left-0 w-[580px] h-[670px]">
            {images.map((src, index) => (
              <Image
                key={index}
                src={src}
                alt={`Global presence desktop ${index}`}
                fill
                className={`object-contain object-left-bottom transition-opacity duration-1000 ${
                  index === current ? "opacity-100" : "opacity-0"
                }`}
                priority={index === 0}
              />
            ))}
            {/* Address Details Overlay */}
            <div className="absolute bottom-0 left-0 md:w-[600px] w-full md:h-[700px] h-[677px] pointer-events-none z-20">
              {locationData.map((location, index) => (
                <div
                  key={index}
                  className={`overlay-location-${index} absolute transition-opacity duration-1000 ${
                    index === current
                      ? "opacity-100 pointer-events-auto"
                      : "opacity-0 pointer-events-none"
                  }`}
                >
                  <div
                    className="bg-white rounded-2xl border border-white md:bg-[linear-gradient(0deg,rgba(255,255,255,0.40),rgba(255,255,255,0.40)),linear-gradient(180deg,rgba(255,255,255,0.30),rgba(51,153,255,0))]
         shadow-[0_0_14px_rgba(4,84,175,0.29)] backdrop-blur-[12px] md:p-2 p-2 md:w-[300px] w-[300px]"
                  >
                    {/* City Header */}
                    <h3 className="text-[#39F] font-semibold md:text-lg text-base text-center uppercase tracking-wide">
                      {location.city}
                    </h3>

                    {/* Address */}
                    <p className="text-[#212953] md:text-base text-sm leading-[18px] text-left mb-0.5 pr-4">
                      {location.address}
                      <br />
                      {location.statePin}
                    </p>

                    {/* Phone */}
                    <a
                      href={`tel:${location.phone_no}`}
                      className="text-[#3399FF] text-base font-normal hover:underline flex items-center justify-start gap-1 mb-0.5"
                    >
                      <Image
                        src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/phone.webp"
                        alt="phone"
                        width={11}
                        height={11}
                        className="flex-shrink-0"
                      />
                      <span className="underline">{location.phone}</span>
                    </a>

                    {/* Email */}
                    <a
                      href={`mailto:${location.email}`}
                      className="text-[#3399FF] text-base font-normal hover:underline break-all flex items-center justify-start gap-1"
                    >
                      <Image
                        src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/email.webp"
                        alt="email"
                        width={11}
                        height={11}
                        className="flex-shrink-0"
                      />
                      <span className="underline">{location.email}</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile image slider */}
        <div className="block md:hidden absolute bottom-0 left-0 w-full h-[550px]">
          {mob_images.map((src, index) => (
            <Image
              key={index}
              src={src}
              alt={`Global presence mobile ${index}`}
              fill
              className={`object-contain object-left-bottom transition-opacity duration-1000 w-full ${
                index === current ? "opacity-100" : "opacity-0"
              }`}
              priority={index === 0}
            />
          ))}
          <div className="absolute bottom-0 left-0 md:w-[600px] w-full md:h-[700px] h-[677px] pointer-events-none z-20">
            {locationData.map((location, index) => (
              <div
                key={index}
                className={`overlay-location-${index} absolute transition-opacity duration-1000 ${
                  index === current
                    ? "opacity-100 pointer-events-auto"
                    : "opacity-0 pointer-events-none"
                }`}
              >
                {/* Mobile div overlay */}
                <div
                  className="bg-white rounded-2xl border border-white md:bg-[linear-gradient(0deg,rgba(255,255,255,0.40),rgba(255,255,255,0.40)),linear-gradient(180deg,rgba(255,255,255,0.30),rgba(51,153,255,0))]
         shadow-[0_0_14px_rgba(4,84,175,0.29)] backdrop-blur-[12px] md:p-2 p-2 md:w-[300px] w-[300px]"
                >
                  {/* City Header */}
                  <h3 className="text-[#39F] font-semibold md:text-lg text-base text-center uppercase tracking-wide">
                    {location.city}
                  </h3>

                  {/* Address */}
                  <p className="text-[#212953] md:text-base text-sm leading-[18px] text-left mb-0.5 pr-2">
                    {location.address}
                    <br />
                    {location.statePin}
                  </p>

                  {/* Phone */}
                  <a
                    href={`tel:${location.phone_no}`}
                    className="text-[#3399FF] text-base font-normal hover:underline flex items-center justify-start gap-1"
                  >
                    <Image
                      src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/phone.webp"
                      alt="phone"
                      width={11}
                      height={11}
                      className="flex-shrink-0"
                    />
                    <span className="underline">{location.phone}</span>
                  </a>

                  {/* Email */}
                  <a
                    href={`mailto:${location.email}`}
                    className="text-[#3399FF] text-base font-normal hover:underline break-all flex items-center justify-start gap-1"
                  >
                    <Image
                      src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/email.webp"
                      alt="email"
                      width={11}
                      height={11}
                      className="flex-shrink-0"
                    />
                    <span className="underline">{location.email}</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="main_container mx-auto relative pt-5 lg:pt-8 pb-0 flex flex-col gap-3 lg:gap-7 z-10 h-[610px] md:flex md:items-end">
          <div className="lg_desktop absolute bottom-[-90px] left-0 w-[590px] h-[600px]">
            {images.map((src, index) => (
              <Image
                key={index}
                src={src}
                alt={`Global presence desktop ${index}`}
                fill
                className={`object-contain object-left-bottom transition-opacity duration-1000 ${
                  index === current ? "opacity-100" : "opacity-0"
                }`}
                priority={index === 0}
              />
            ))}
            {/* Address Details Overlay md */}
            <div className="absolute bottom-0 left-0 md:w-[600px] w-full md:h-[700px] h-[677px] pointer-events-none z-20">
              {locationData.map((location, index) => (
                <div
                  key={index}
                  className={`overlay-location-${index} absolute transition-opacity duration-1000 ${
                    index === current
                      ? "opacity-100 pointer-events-auto"
                      : "opacity-0 pointer-events-none"
                  }`}
                >
                  <div
                    className="bg-white rounded-2xl border border-white md:bg-[linear-gradient(0deg,rgba(255,255,255,0.40),rgba(255,255,255,0.40)),linear-gradient(180deg,rgba(255,255,255,0.30),rgba(51,153,255,0))]
         shadow-[0_0_14px_rgba(4,84,175,0.29)] backdrop-blur-[12px] md:p-2 p-2 md:w-[300px] w-[300px]"
                  >
                    {/* City Header */}
                    <h3 className="text-[#39F] font-semibold md:text-lg text-base text-center uppercase tracking-wide">
                      {location.city}
                    </h3>

                    {/* Address */}
                    <p className="text-[#212953] md:text-base text-sm leading-[18px] text-left mb-0.5 pr-4">
                      {location.address}
                      <br />
                      {location.statePin}
                    </p>

                    {/* Phone */}
                    <a
                      href={`tel:${location.phone_no}`}
                      className="text-[#3399FF] text-base font-normal hover:underline flex items-center justify-start gap-1 mb-0.5"
                    >
                      <Image
                        src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/phone.webp"
                        alt="phone"
                        width={11}
                        height={11}
                        className="flex-shrink-0"
                      />
                      <span className="underline">{location.phone}</span>
                    </a>

                    {/* Email */}
                    <a
                      href={`mailto:${location.email}`}
                      className="text-[#3399FF] text-base font-normal hover:underline break-all flex items-center justify-start gap-1"
                    >
                      <Image
                        src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/email.webp"
                        alt="email"
                        width={11}
                        height={11}
                        className="flex-shrink-0"
                      />
                      <span className="underline">{location.email}</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full">
            <h1 className="font-baskerville text-[#39F] font-bold text-[28px] md:text-[40px] text-center">
              Miles’ Global Presence
            </h1>
            <p className="font-baskerville text-[#081C31] text-sm md:text-xl font-bold text-center mb-2">
              Proudly serving learners across 80+ cities
            </p>
          </div>

          {/* Form box */}
          <div
            className="md:w-[400px] w-full px-4 py-2 border border-white rounded-2xl md:mt-0 mt-3 z-40"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
              boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
              backdropFilter: "blur(28px)",
            }}
          >
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
              alt="star group"
              width={34}
              height={38}
              className="absolute top-1 left-0"
            />
            <GlobalForm
              formType="contact_us"
              formHeading={FormHeading.CONTACT_US}
              pageType={OtherFormCategory.CONTACT_US}
              submitButtonName="Get In Touch"
              showSVG={false}
              successMessage={SuccessMessageType.CONTACT_US}
              darkBackground={false}
              isAStepperForm
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactBanner;
